import script from "./DetalleRutas.vue?vue&type=script&setup=true&lang=js"
export * from "./DetalleRutas.vue?vue&type=script&setup=true&lang=js"

import "./DetalleRutas.vue?vue&type=style&index=0&id=533f98d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-533f98d6"]])

export default __exports__